import { GzDashboardAppWebComponent } from '../component/GzDashboardAppWebComponent';
import { GzDashboardAppRepository } from '../repository/GzDashboardAppRepository';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { GzDashboardAppView } from '../view/GzDashboardAppView';
import { templateGzDashboardApp } from '../view/template';
import { InitGenericDashboardResponse } from '@nirvana/shared/dtos/types/generic-dashboards/gz-console';

export class GzDashboardAppController extends BaseWebComponentController {
  public component: GzDashboardAppWebComponent;
  public dataRepository: GzDashboardAppRepository;
  public view: GzDashboardAppView;
  public viewConstructor: typeof GzDashboardAppView;
  public dataRepositoryConstructor: typeof GzDashboardAppRepository;

  constructor(component: GzDashboardAppWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: GzDashboardAppView,
      viewTemplate: templateGzDashboardApp,
      dataRepositoryConstructor: GzDashboardAppRepository,
    });
  }

  async getDataForView(): Promise<InitGenericDashboardResponse> {
    this.view.buildLoadingTemplate();
    return this.dataRepository.computeUserConfigForDashboard({
      dashboardType: this.component.dashboardType,
      lng: Application.Main.getLanguage(),
    });
  }
}
